module.exports = __webpack_public_path__ + "img/d36ee49.webp";